const DEFAULT_AVATAR = '/avatars/avatar-default.webp'
const AVATARS_PATH = '/avatars'

/**
 * Get avatar image source path from filename
 * @param {string|null|undefined} avatarFilename - Avatar filename (e.g., 'avatar-1.webp') or null
 * @returns {string} Full path to avatar image
 */
export function getAvatarSrc (avatarFilename) {
  if (!avatarFilename) {
    return DEFAULT_AVATAR
  }
  return `${AVATARS_PATH}/${avatarFilename}`
}
